import * as React from 'react'

import { makeStyles } from '@material-ui/core/styles'
import { TextField, useListContext, Datagrid } from 'react-admin'

import { lightergray3 } from '../../constants/colorConstants'
import tracker from '../../utils/tracker'
import { CurrencyField } from '../fields/currencyField'
import { LocalDateField } from '../fields/localDateField'

const useStyles = makeStyles({
  grey: {
    backgroundColor: lightergray3,
  },
  headerRightWithoutIconGrey: {
    backgroundColor: lightergray3,
    textAlign: 'right',
    paddingRight: '30px',
    background: 'transparent',
  },
})

const handleInvoiceClick = (record) => {
  tracker.event({
    action: 'credit_line_details_invoice_advance_link_clicked',
    category: 'creditLine',
    label: 'invoiceAdvanceStatus',
    value: record?.status,
  })
}

export const EventCreditLineDatagrid = () => {
  const classes = useStyles()
  const ctx = useListContext()

  return (
    <Datagrid className={classes.grey} {...ctx}>
      <TextField
        source="invoiceNumber"
        label={'resources.creditlines.events.invoice'}
        headerClassName={classes.grey}
        onClick={handleInvoiceClick}
      />
      <LocalDateField
        source="issuedDate"
        label={'resources.creditlines.events.issueDate'}
        headerClassName={classes.grey}
      />
      <LocalDateField
        source="dueDate"
        label={'resources.creditlines.events.dueDate'}
        headerClassName={classes.grey}
      />
      <CurrencyField
        source="repaymentAmount"
        label={'resources.creditlines.events.repaidAmount'}
        headerClassName={classes.headerRightWithoutIconGrey}
      />
      <TextField headerClassName={classes.grey} />
    </Datagrid>
  )
}
